import * as PropTypes from "prop-types"
import { color } from "helpers/styled"
import styled from "styled-components"
import Item from "../Item"

const SpecialCard = styled(Item)`
  --promo-bg: linear-gradient(110deg, ${color("yellow")} 6%, ${color("deepPink")} 105%);
  --promo-color: ${color("darkBlue")};
  --promo-border: solid 0.8px ${color("deepPink")};
`

function Special({ title, description }) {
  return <SpecialCard title={title} description={description} image="medal" alt="Special Promotion" />
}

Special.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default Special
